import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
} from "@mui/material";

import { getAdminPayments } from "../../api/adminApi";

const STATUS_OPTIONS = [
  { label: "All", value: "" },
  { label: "pending", value: "pending" },
  { label: "paid", value: "paid" },
  { label: "refunded", value: "refunded" },
  { label: "failed", value: "failed" },
];

export default function AdminPayments() {
  const [status, setStatus] = useState("");
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const params = useMemo(() => {
    const p = {};
    if (status) p.status = status;
    return p;
  }, [status]);

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await getAdminPayments(params);
      setItems(res.data?.items || []);
    } catch (e) {
      console.error(e);
      setError("Failed to load payments.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status]);

  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
        Payments Ledger
      </Typography>
      <Typography sx={{ mb: 2, color: "text.secondary" }}>
        Paid / pending / refunded list.
      </Typography>

      <Box sx={{ display: "flex", gap: 2, alignItems: "center", mb: 2 }}>
        <FormControl size="small" sx={{ minWidth: 180 }}>
          <InputLabel>Status</InputLabel>
          <Select value={status} label="Status" onChange={(e) => setStatus(e.target.value)}>
            {STATUS_OPTIONS.map((o) => (
              <MenuItem key={o.label} value={o.value}>
                {o.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button variant="outlined" onClick={load} disabled={loading}>
          Refresh
        </Button>

        {loading && <Typography sx={{ color: "text.secondary" }}>Loading…</Typography>}
        {error && <Typography sx={{ color: "error.main" }}>{error}</Typography>}
      </Box>

      <TableContainer component={Paper}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Order</TableCell>
              <TableCell>Amount</TableCell>
              <TableCell>Currency</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Method</TableCell>
              <TableCell>External Ref</TableCell>
              <TableCell>Notes</TableCell>
              <TableCell>Created</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {items.map((p) => (
              <TableRow key={p.id}>
                <TableCell>{p.id}</TableCell>
                <TableCell>{p.order_id}</TableCell>
                <TableCell>{p.amount}</TableCell>
                <TableCell>{p.currency}</TableCell>
                <TableCell>{p.status}</TableCell>
                <TableCell>{p.method}</TableCell>
                <TableCell>{p.external_ref || "-"}</TableCell>
                <TableCell>{p.notes || "-"}</TableCell>
                <TableCell>{p.created_at ? new Date(p.created_at).toLocaleString() : "-"}</TableCell>
              </TableRow>
            ))}

            {!items.length && !loading && (
              <TableRow>
                <TableCell colSpan={9} sx={{ color: "text.secondary" }}>
                  No payments found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
